const SEPARATOR = '_';

export type FrefListId = 'splp' | 'rplp';
export type FrefListName = 'bia' | 'biacart' | 'fbt';

export type FrefParams = {
    listId: FrefListId;
    listName: FrefListName;
    index: number;
};

export const encodeFref = ({ listId, listName, index }: FrefParams): string => {
    const searchParams = new URLSearchParams();
    searchParams.set('fref', [listId, listName, index].join(SEPARATOR));
    return searchParams.toString();
};
